import { makeStyles, Typography, LayoutGrid, createButton, keygen } from '@archer-technologies/ui-components';
import { TableHeaderRow, Table } from '@devexpress/dx-react-grid-material-ui';
import { createElement } from 'react';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { Plugin, Getter, Template, TemplateConnector } from '@devexpress/dx-react-core';
import TableCell from '@mui/material/TableCell';
var useStyles = makeStyles(function () {
  return {
    cellStyle: {
      padding: '0 !important'
    },
    blankStyle: {
      visibility: 'hidden'
    }
  };
});
var pluginDependencies = [{
  name: 'Table'
}];

var buildActionToolbar = function buildActionToolbar(actions, translate, row, blankStyle) {
  var iconButtonTypes = actions.map(function (action) {
    return action.type;
  });
  var actionsList = actions && actions.filter(function (action) {
    return !action.hiddenIndex || !row[action.hiddenIndex]; // Remove all items that need to be hidden
  }).map(function (_ref) {
    var id = _ref.id,
        type = _ref.type,
        actionType = _ref.actionType,
        tooltipTitle = _ref.tooltipTitle,
        _onClick = _ref.onClick,
        disabledIndex = _ref.disabledIndex,
        dataProp = _ref.dataProp;
    return {
      id: id,
      isIconButton: true,
      dataProp: dataProp,
      size: 'medium',
      type: type,
      showText: false,
      onClick: function onClick() {
        return _onClick({
          row: row
        });
      },
      actionType: actionType,
      tooltipTitle: tooltipTitle,
      toolTipPosition: 'top',
      disabled: disabledIndex ? row[disabledIndex] : false,
      translate: translate
    };
  }); // add blank icon where icons are hidden, to keep spacing equal in Grid column

  var missingIcon = iconButtonTypes.filter(function (item) {
    return !actionsList.map(function (action) {
      return action.type;
    }).includes(item);
  });

  var newIconButtonTypes = function newIconButtonTypes(iconButtonTypes, missingIcon) {
    return iconButtonTypes && iconButtonTypes.map(function (item) {
      return missingIcon && missingIcon.find(function (action) {
        return action === item;
      }) && 'BLANK' || item;
    });
  };

  var getMissingId = function getMissingId(iconButtonTypes, missingIcon) {
    return newIconButtonTypes(iconButtonTypes, missingIcon).indexOf('BLANK') + 1;
  };

  newIconButtonTypes(iconButtonTypes, missingIcon).forEach(function (item) {
    if (item && item === 'BLANK') {
      actionsList.push({
        id: getMissingId(iconButtonTypes, missingIcon),
        isIconButton: true,
        size: 'medium',
        type: 'BLANK',
        showText: false,
        disabled: true,
        onClick: undefined,
        translate: translate,
        classes: blankStyle ? blankStyle : ''
      });
    }
  }); // arraySort

  var compareId = function compareId(item1, item2) {
    if (item1 && item2 && item1.id && item2.id && item1.id > item2.id) {
      return 1;
    }

    if (item1 && item2 && item1.id && item2.id && item1.id < item2.id) {
      return -1;
    }

    return 0;
  };

  actionsList.sort(compareId);
  actionsList.forEach(function (item) {
    item.id = "".concat(item.id, "$").concat(keygen());
    return item;
  });
  return /*#__PURE__*/createElement(LayoutGrid, {
    container: true,
    justify: "center"
  }, actionsList.map(function (element) {
    return createButton(element);
  }));
};

var ActionsPlugin = function ActionsPlugin(_ref2) {
  var actions = _ref2.actions,
      messages = _ref2.messages,
      translate = _ref2.translate;

  var _useStyles = useStyles(),
      cellStyle = _useStyles.cellStyle,
      blankStyle = _useStyles.blankStyle;

  return /*#__PURE__*/createElement(Plugin, {
    name: "ActionColumn",
    dependencies: pluginDependencies
  }, /*#__PURE__*/createElement(Getter, {
    name: "tableColumns",
    computed: function computed(_ref3) {
      var tableColumns = _ref3.tableColumns;
      return [].concat(_toConsumableArray(tableColumns), [{
        type: 'action',
        key: Symbol('Actions').toString()
      }]);
    }
  }), /*#__PURE__*/createElement(Template, {
    name: "tableCell",
    predicate: function predicate(_ref4) {
      var tableColumn = _ref4.tableColumn,
          tableRow = _ref4.tableRow;
      return tableColumn.type === 'action' && tableRow.type === TableHeaderRow.ROW_TYPE;
    }
  }, /*#__PURE__*/createElement(TemplateConnector, null, function () {
    return /*#__PURE__*/createElement(TableCell, {
      style: {
        padding: 0
      }
    }, /*#__PURE__*/createElement(Typography, {
      variant: "h6",
      color: "textPrimary",
      align: "center"
    }, messages.get('actionHeader')));
  })), /*#__PURE__*/createElement(Template, {
    name: "tableCell",
    predicate: function predicate(_ref5) {
      var tableColumn = _ref5.tableColumn,
          tableRow = _ref5.tableRow;
      return tableColumn.type === 'action' && tableRow.type === Table.ROW_TYPE;
    }
  }, function (params) {
    return /*#__PURE__*/createElement(TemplateConnector, null, function () {
      var row = params.tableRow.row;
      return /*#__PURE__*/createElement(TableCell, {
        className: cellStyle
      }, buildActionToolbar(actions, translate, row, blankStyle));
    });
  }));
};

export { ActionsPlugin };